import React from 'react';

import { bemBlock } from '../../modules/bem';
import * as layout from '../../modules/layout';
import { Card } from '../card/Card';
import { LayoutFill } from '../layout-fill/LayoutFill';

import ModalClose from './ModalClose';

import './ModalHeader.less';

export interface ModalHeaderProps {
  className?: string;
  title?: React.ReactNode;
  onClose?: () => void;
  alignItems?: layout.AlignItems;
}

const block = bemBlock('n-modal-header');

const DATA_ROLE = 'modal-header';

const ModalHeader: React.FC<ModalHeaderProps> = ({
  className,
  title,
  children,
  onClose,
  alignItems,
  ...props
}) => {
  const cssClass = block({ extra: className });

  if (children) {
    return (
      <Card.Section
        data-role={DATA_ROLE}
        className={cssClass}
        alignItems={alignItems}
        span="shrink"
      >
        {children}
      </Card.Section>
    );
  }

  const titleElement = <Card.HeaderText className={block('title')}>{title}</Card.HeaderText>;

  const closeElement = onClose ? <ModalClose onClose={onClose} /> : null;

  return (
    <Card.Section
      className={cssClass}
      data-role={DATA_ROLE}
      {...props}
      alignItems="baseline"
      span="shrink"
    >
      {titleElement}
      <LayoutFill />
      {closeElement}
    </Card.Section>
  );
};

export default ModalHeader;
